<div class="add-part">
  <!-- header -->
  <div class="part-header mb-0">
    <div class="ui-g-12 flex-between-center p-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tire header-icon ml"></i>
        <div class="width-100p p-relative font-600 font-16">Tire Storage Details</div>
      </div>
      <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog(false)"></i>
    </div>
  </div>

  <!-- Start Add New Parts Body -->
  <div class="ui-g part-body pt-0 pb-0 border-bottom-light" *ngIf="!isLoadingTireStorageModal">
    <div class="ui-g-3 inputs-column-spacing part-inner-body pr-0">
      <div class="w-98">
        <div class="pointer sidebar-item" (click)="scrollToSection('basic')" [ngClass]="selectedSidebarTab === 'basic' && 'active'">Basic Information</div>
        <div class="pointer sidebar-item" (click)="scrollToSection('pricing')" [ngClass]="selectedSidebarTab === 'pricing' && 'active'">Pricing</div>
        <div *ngIf="isNewCategoriesEnabled" class="pointer sidebar-item" (click)="scrollToSection('classification')" [ngClass]="selectedSidebarTab === 'classification' && 'active'">Tire Storage Classification</div>
        <div class="pointer sidebar-item" (click)="scrollToSection('settings')" [ngClass]="selectedSidebarTab === 'settings' && 'active'">Tire Storage Settings</div>
        <div class="pointer sidebar-item" (click)="scrollToSection('additionalDetails')" [ngClass]="selectedSidebarTab === 'additionalDetails' && 'active'">Additional Details</div>

        <div class="pointer sidebar-item mt-2 flex-between-center" (click)="onTabSelect(1)" [ngClass]="selectedTab === 1 && 'active'">
          <div>Activity Logs</div>
          <div>
            <i class="fas fa-chevron-right font-secondary"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-9 inputs-column-spacing part-inner-body" #partBody [hidden]="selectedTab === 1">
      <!-- Basic Info section -->
      <div class="input-basic-info-wrapper ui-g-12 mb-2 height-250p" id="basic">
        <h5 class="input-heading">Basic Information</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-6 p-0 flex-start-center mt-3">
            <div class="width-100p primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">How many tires are we storing?</label>
              </div>
              <app-input
                id="tire-count"
                type="text"
                placeholder="Enter the number of tires"
                theme="border"
                [allowDecimal]="true"
                [fontSize]="14"
                name="count"
                [autoFocus]="true"
                [value]="tireStorage.count"
                [maxLength]="50"
                [disabled]="invoicedRO"
                (appFocus)="focusInput('count')"
                (appBlur)="blurInput('count')"
                (appChange)="handleChange('count', $event)"
              >
              </app-input>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center mt-3">
            <div class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Add Inspection*</label>
              </div>

              <app-dropdown
                id="inspection"
                listId="inspection-list"
                field="name"
                scrollHeight="180px"
                placeholder="Select from list"
                styleClassValue="text-truncate"
                itemWidth="394px"
                theme="border"
                styleClassError="dropdown-error-border-top"
                [hasError]="errors.associatedInspection"
                [errorMessage]="errors.associatedInspection"
                [isDropdownIconVisible]="true"
                [fontSize]="16"
                [value]="tireStorage?.associatedInspection"
                [options]="cannedInspections"
                [listItemFontSize]="14"
                (appSelect)="handleChange('associatedInspection', $event)"
              ></app-dropdown>
            </div>
          </div>

          <div *ngIf="companyLocalization; else nameLocalizationFlag">
            <div class="ui-g-6 p-0 flex-start-center mt-3">
              <div class="width-100p primary-active-border">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Line Item Description (EN){{ currentLang === 'en' ? '*' : '' }}</label>
                </div>
                <app-input
                  id="tire-title"
                  type="text"
                  [placeholder]="'Add line description here'"
                  theme="border"
                  [fontSize]="14"
                  name="title"
                  [value]="tireStorage.title"
                  [maxLength]="50"
                  [isInvalid]="errors.title"
                  [errorMessage]="errors.title"
                  (appFocus)="focusInput('title')"
                  (appBlur)="blurInput('title', $event)"
                  (appChange)="handleChange('title', $event)"
                >
                </app-input>
              </div>
            </div>

            <div class="ui-g-6 p-0 flex-start-center mt-3">
              <div class="width-100p pl-2 primary-active-border">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Line Item Description (FR){{ currentLang === 'fr' ? '*' : '' }}</label>
                </div>
                <app-input
                  id="tire-titleFR"
                  type="text"
                  [placeholder]="'Add line description here'"
                  theme="border"
                  [fontSize]="14"
                  name="titleFR"
                  [value]="tireStorage.titleFR"
                  [maxLength]="50"
                  [isInvalid]="errors.titleFR"
                  [errorMessage]="errors.titleFR"
                  (appFocus)="focusInput('titleFR')"
                  (appBlur)="blurInput('titleFR', $event)"
                  (appChange)="handleChange('titleFR', $event)"
                >
                </app-input>
              </div>
            </div>
          </div>

          <ng-template #nameLocalizationFlag>
            <div class="ui-g-6 p-0 flex-start-center mt-3">
              <div class="width-100p primary-active-border">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Line Item Description*</label>
                </div>
                <app-input
                  id="tire-title"
                  type="text"
                  [placeholder]="'Add line description here'"
                  theme="border"
                  [fontSize]="14"
                  name="title"
                  [value]="tireStorage.title"
                  [maxLength]="50"
                  [isInvalid]="errors.title"
                  [errorMessage]="errors.title"
                  (appFocus)="focusInput('title')"
                  (appBlur)="blurInput('title', $event)"
                  (appChange)="handleChange('title', $event)"
                >
                </app-input>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="input-basic-info-wrapper ui-g-12 mb-2 pricing-section" id="pricing">
        <h5 class="input-heading">Pricing</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-2 p-0 flex-start-center mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Pricing</label>
              </div>

              <div class="ui-g-12 p-0 customer-type-switch tire-storage-switch">
                <app-switch-button
                  id="pricing-type-switch"
                  valueField="value"
                  paddingClass="p-1"
                  [disabled]="false"
                  [fontSize]="14"
                  [showselectedCircle]="false"
                  [value]="tireStorage.pricingType"
                  [options]="pricingOptions"
                  (appChange)="handleChange('pricingType', $event)"
                >
                </app-switch-button>
              </div>
            </div>
          </div>

          <div class="ui-g-5 p-0 flex-start-center mt-3">
            <div class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Cost* {{ tireStorage?.pricingType?.value === 'perTire' ? '(per tire)' : '' }}</label>
              </div>

              <app-input
                id="tire-cost"
                type="text"
                [placeholder]="tireStorage?.pricingType?.value === 'flatFee' ? 'Enter total cost' : 'Enter cost per tire'"
                theme="border"
                [fontSize]="14"
                name="cost"
                [allowDecimal]="true"
                [value]="focus?.cost ? tireStorage.cost : (tireStorage.cost | currency: usd)"
                [maxLength]="50"
                [isInvalid]="errors.cost"
                [errorMessage]="errors.cost"
                [disabled]="false"
                (appFocus)="focusInput('cost')"
                (appBlur)="blurInput('cost')"
                (appKeyUp)="handleChange('cost', $event)"
              >
              </app-input>
            </div>
          </div>

          <div class="ui-g-5 p-0 flex-start-center part-add-auto-complete mt-3">
            <div class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Price* {{ tireStorage?.pricingType?.value === 'perTire' ? '(per tire)' : '' }}</label>
              </div>
              <app-input
                id="tire-price"
                type="text"
                [placeholder]="tireStorage?.pricingType?.value === 'flatFee' ? 'Enter total price' : 'Enter price per tire'"
                theme="border"
                [fontSize]="14"
                [allowDecimal]="true"
                name="price"
                [value]="focus?.price ? tireStorage.price : (tireStorage.price | currency: usd)"
                [maxLength]="50"
                [isInvalid]="errors.price"
                [errorMessage]="errors.price"
                (appFocus)="focusInput('price')"
                (appBlur)="blurInput('price', $event)"
                (appKeyUp)="handleChange('price', $event)"
              >
              </app-input>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isNewCategoriesEnabled" class="input-basic-info-wrapper input-default-style ui-g-12 p-0" id="classification">
        <h5 class="input-heading">Item Type Classification</h5>

        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-6 p-0 flex-start-center mt-3">
            <div class="width-100p pr-2 primary-active-border disabled-input">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Tire Storage Category</label>
              </div>
              <app-input id="tire-number" type="text" [disabled]="true" theme="border" [fontSize]="14" name="number" [autoFocus]="true" [value]="tireStorage?.category?.categoryName || 'Tire Storage'" [maxLength]="50"> </app-input>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center mt-3">
            <div *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled" class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Sales Code</label>
              </div>

              <div class="ui-g-12 p-0 flex-start-center">
                <div *ngIf="tireStorage.salesCode?.title" class="badge-text flex-start-center">
                  {{ tireStorage?.salesCode?.title }}&nbsp;({{ tireStorage?.salesCode?.shortName }})
                  <img
                    src="assets/img/icon/edit-outline.svg"
                    class="pointer"
                    tooltipPosition="top"
                    tooltipStyleClass="tooltip-width-medium text-center"
                    [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''"
                    (click)="openAssignSalesCodeDialog()"
                  />
                </div>
                <div
                  *ngIf="!tireStorage.salesCode?.title"
                  tooltipPosition="top"
                  tooltipStyleClass="tooltip-width-medium text-center"
                  [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''"
                  class="badge-text warning pointer"
                  (click)="openAssignSalesCodeDialog()"
                >
                  Assign
                  <i class="far fa-plus"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="input-basic-info-wrapper ui-g-12 mb-2 pricing-section" id="settings">
        <h5 class="input-heading">Tire Storage Settings</h5>

        <div class="ui-g-12 p-0 flex-start-center part-add-auto-complete mt-2">
          <app-switch-pill
            id="mark-as-fluid"
            label="Taxable"
            position="end"
            styleClassLabel="font-gray-35"
            [fontSize]="12"
            [isActive]="tireStorage.isTaxable"
            (appChange)="handleChange('isTaxable', $event)"
          >
          </app-switch-pill>
        </div>

        <div class="ui-g-12 p-0 flex-start-center part-add-auto-complete mt-2">
          <app-switch-pill id="mark-as-fluid" label="Active" position="end" styleClassLabel="font-gray-35" [disabled]="isOpenFromRO" [fontSize]="12" [isActive]="tireStorage.status" (appChange)="handleChange('status', $event)">
          </app-switch-pill>
        </div>

        <div class="ui-g-12 p-0 flex-start-center part-add-auto-complete mt-2">
          <app-switch-pill
            id="mark-as-fluid"
            label="Commissionable"
            position="end"
            styleClassLabel="font-gray-35"
            [fontSize]="12"
            [isActive]="tireStorage.commissionable"
            (appChange)="handleChange('commissionable', $event)"
          >
          </app-switch-pill>
        </div>

        <div class="ui-g-12 p-0 flex-start-center part-add-auto-complete mt-2">
          <app-switch-pill
            id="mark-as-fluid"
            label="Display Part Description on estimate and invoice"
            position="end"
            styleClassLabel="font-gray-35"
            [fontSize]="12"
            [isActive]="tireStorage.displayDescOnOrder"
            (appChange)="handleChange('displayDescOnOrder', $event)"
          >
          </app-switch-pill>
        </div>

        <div class="ui-g-12 p-0 flex-start-center part-add-auto-complete mt-2">
          <app-switch-pill
            id="mark-as-fluid"
            label="Display Quantity and Price on estimate and invoice"
            position="end"
            styleClassLabel="font-gray-35"
            [fontSize]="12"
            [isActive]="tireStorage.displayHoursOnOrder"
            (appChange)="handleChange('displayHoursOnOrder', $event)"
          >
          </app-switch-pill>
        </div>
      </div>

      <!-- Additional details info section -->
      <div class="input-basic-info-wrapper ui-g-12 mb-4" id="additionalDetails">
        <h5 class="input-heading">Additional Notes</h5>

        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-12 p-0 flex-start-center mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Internal Notes (Optional)</label>
              </div>
              <app-textarea
                textAreaId="Notes"
                theme="border"
                placeholder="Add notes here"
                [maxLength]="10000"
                [floatingLabel]="false"
                [autoGrow]="true"
                [maxAutoGrowHeight]="64"
                [fontSize]="14"
                [rows]="1"
                [value]="tireStorage.internalNotes"
                (appChange)="handleChange('internalNotes', $event)"
                (appFocus)="focusInput('internalNotes')"
                (appBlur)="blurInput('internalNotes')"
              >
              </app-textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- Additional details info section ends-->
    </div>

    <div class="ui-g-9 inputs-column-spacing part-inner-body" #partBody [hidden]="selectedTab === 0">
      <div class="input-basic-info-wrapper ui-g-12 mb-2 height-550px" id="basic">
        <h5 class="input-heading">Activity Logs</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <div class="activity-logs">
            <div class="catalog-activity-wrapper">
              <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
                <div *ngFor="let activityLog of activityLogs">
                  <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
                </div>
              </div>
              <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
                <p>There are no activity logs.</p>
              </div>
              <!-- <div class="filter-ddl-wrapper">
                                <div class="dropdown">
                                    <div class="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        Filter &nbsp;
                                        <i *ngIf="isFilterLoading" class="fal fa-spinner rotate"></i>
                                        <span *ngIf="filterOption?.length" class="filter-count-bubble">{{
                                            selectedFilterOptionLength
                                            }}</span>
                                    </div>

                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                                        <ul class="catalog-list-filter">
                                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                                                <app-checkbox label="Item history"
                                                    [isChecked]="filterOptionModel.itemHistory" [fontSize]="12"
                                                    (appChange)="onCheckboxChange($event, 'catalog-item')">
                                                </app-checkbox>
                                            </li>
                                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                                                <app-checkbox label="Pricing history"
                                                    [isChecked]="filterOptionModel.pricingHistory" [fontSize]="12"
                                                    (appChange)="onCheckboxChange($event, 'item-pricing')">
                                                </app-checkbox>
                                            </li>
                                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                                                <app-checkbox label="Purchase history"
                                                    [isChecked]="filterOptionModel.purchaseHistory" [fontSize]="12"
                                                    (appChange)="onCheckboxChange($event, 'ci-purchase-history-po')">
                                                </app-checkbox>
                                            </li>
                                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                                                <app-checkbox label="Selling history"
                                                    [isChecked]="filterOptionModel.sellingHistory" [fontSize]="12"
                                                    (appChange)="onCheckboxChange($event, 'ci-sale-history-ro')">
                                                </app-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Add New Parts Body -->

  <div class="part-body flex-center-center" *ngIf="isLoadingTireStorageModal">
    <span class="flex-row font-18 flex-center-center">
      <i class="fa fa-spinner rotate"></i>
    </span>
  </div>

  <!-- Start Add Parts Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer">
    <div class="part-add-dialog-footer d-flex justify-content-end width-100p">
      <div>
        <button id="part-cancel-btn" class="btn btn-border pointer btn-submit mr-1" (click)="closeDialog()">Cancel</button>

        <button id="part-save-btn" class="btn btn-primary btn-submit" [disabled]="isProcessing || isLoading || isFinalizedRo" 
        tooltipPosition="top" [pTooltip]="isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''" (click)="onSubmit()">
          <span [ngClass]="{ 'pr-2': isProcessing || isLoading }">Save</span>
          <i *ngIf="isProcessing || isLoading" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
</div>
